import { useContext } from 'react';

import { CarsContext } from '../context/cars';

export const useCars = () => {
  const context = useContext(CarsContext);

  if (!context) {
    throw new Error('useCars must be used within a CarsContextProvider')
  }

  return context;
}